export class Admin {
  id?: string;
  name?: string;
  email?: string;
  designation?: string;
  status?: string;
  phoneCode?: string;
  mobileNumber?: string;
}

export enum Status {
  TRUE = 'true',
  FALSE = 'false',
}

export class hr {
  email?: string;
  oldPassword?: string;
  newPassword?: string;
  confirmPassword?: string;
}
export class Group {
  id?: string;
  name?: string;
  subCategoryId?: string;
}
